import React, { FC, ReactElement } from 'react';

import styled from 'styled-components';

import Markdown from '@components/utils/Markdown';
import { Modal, ModalApi } from '@components/Modal';

const Content = styled.p`
  margin: 0;
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 767px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }

  a {
    color: ${(p) => p.theme.palette.primaryBrand};
  }
`;

const staticProps = {
  width: 833,
};
const InfoModal: FC<{
  title?: ReactElement | string;
  content: React.ReactNode;
  onCancel?(): void;
  reservationPage?: boolean;
}> = ({ title, content, onCancel, reservationPage, ...rest }) => {
  const isString = typeof content === 'string';
  return (
    <Modal
      padding={reservationPage ? '44px 0px 0px 0px' : ''}
      title={title}
      isVisible={true}
      onCancel={onCancel}
      {...staticProps}
      {...rest}
    >
      <Content>{isString ? <Markdown text={content} /> : content}</Content>
    </Modal>
  );
};

export default InfoModal;

export type { ModalApi };
